import axios from "axios";

const instance = axios.create({
  // baseURL: "http://localhost:3000",
  // baseURL: "https://api.loyalpartners.com.au",
  baseURL: "http://192.168.0.173:3000",
});

export default instance;
